import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .LRContent': {
    position: 'relative',
    zIndex: 2,
  },
  '& .LRBackground': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    maxHeight: '100vh',
  },
  '& .LRBGOverlay': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 1,
    background: `linear-gradient(
        180deg,
        ${alpha(theme.palette.background.primary, 0.75)} 0%,
        ${theme.palette.background.primary} 100%
      )`,
  },
}));
export default StyledBox;
